import Auth from '@js/plugins/auth';

export default {
    computed: {
        canManagePricebooks() {
            return Auth.hasPermissionTo('franchise_manage_station_pricebook');
        },

        canManageStationPrices() {
            return Auth.hasPermissionTo('franchise_manage_station_price');
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/override_pricebook/override-permission.js